import Vue from 'vue';
import App from './App.vue';
import Router from './router';
import Store from './store';
import MQ from 'vue-match-media/src';

Vue.use(MQ)

Vue.config.productionTip = false;

window.addEventListener('DOMContentLoaded', () => {
  const elements = [...document.querySelectorAll('#configurator')];

  elements.forEach(el => {
    new Vue({
      router: new Router(el.dataset.baseUrl).router,
      store: new Store().store,
      data: () => Object.assign({}, el.dataset),
      mq: {
        desktop: '(min-width: 992px)'
      },
      render: h => h(App),
    }).$mount(el);
  })
});
